const listenerProductsFiltering = () => {
  const $productsContainer = $('.boost-pfs-filter-products');

  if ($productsContainer.length === 0) {
    return;
  }

  const targetNode = $productsContainer[0];

  const config = { attributes: true, childList: false, subtree: false };

  const callback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (! $(mutation.target).hasClass('boost-pfs-filter-product-loading')) {
          const api = new Yotpo.API(yotpo);
          api.refreshWidgets();
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
}

listenerProductsFiltering();
